<template>
    <vue-scroll :ops="ops" ref="vueScroll">
        <div class="product">
            <HeaderMei></HeaderMei>
            <div class="content">
                <div class="text-item">
                    <div class="title">产品理念</div>
                    <div class="english">Product concept</div>
                    <div class="intro">美天科技在与全国各省市企事业单位的长期合作中, 一直致力于提升气象产品的专业程度和智能水平</div>
                </div>
                <div class="text-item">
                    <div class="title">核心产品</div>
                    <div class="english">Core product</div>
                    <div class="intro">我们持续10年专注气象行业, 经过不断摸索, 学习和优化, 逐渐形成了具有美天特色的各项气象产品</div>
                </div>
                <div class="img-items">
                    <div class="img-item" style="margin-right: 10px;" @click="viewChangeClick('cannas')">
                        <div class="img"><img src="../assets/images/qdltq.png"/></div>
                        <div class="name">强对流天气预警一体化平台</div>
                    </div>
                    <div class="img-item" style="margin: 0 10px" @click="viewChangeClick('dl')">
                        <div class="img">
                            <img src="../assets/images/dqqh.png"/>
                        </div>
                        <div class="name">短期气候预测平台</div>
                    </div>
                    <div class="img-item" style="margin-left: 10px;" @click="viewChangeClick('rg')">
                        <div class="img"><img src="../assets/images/rgyxtq.png"/></div>
                        <div class="name">人工影响天气一体化平台</div>
                    </div>
                </div>
                <div class="img-items" style="margin-top: 20px" @click="viewChangeClick('nl')">
                    <div class="img-item" style="margin-right: 10px;">
                        <div class="img"><img src="../assets/images/csnl.png"/></div>
                        <div class="name">城市内涝气候风险预警平台</div>
                    </div>
                    <div class="img-item" style="margin: 0 10px" @click="viewChangeClick('jc')">
                        <div class="img"><img src="../assets/images/jcfx.png"/></div>
                        <div class="name">基层风险报警预警平台</div>
                    </div>
                    <div class="img-item" style="border: none;margin-left: 10px;">
                        <div class="img" style="border: none;margin-left: 10px;"></div>
                        <div class="name" style="border: none;margin-left: 10px;"></div>
                    </div>
                </div>
            </div>
            <FooterMei></FooterMei>
        </div>
    </vue-scroll>
</template>

<script>
import HeaderMei from '@/components/headerMei';
import FooterMei from '@/components/footerMei';

export default {
    name: "product",
    components: { HeaderMei, FooterMei },
    data() {
        return {
            ops: {
                rail: {
                    background: '#01a99a',
                    opacity: 0,
                    size: '0px',
                    specifyBorderRadius: false,
                    gutterOfEnds: null,    //轨道距 x 和 y 轴两端的距离
                    gutterOfSide: '0',   //距离容器的距离
                    keepShow: false,   //是否即使 bar 不存在的情况下也保持显示
                    border: 'none'    //边框
                }
            },
        }
    },
    methods: {
        viewChangeClick(val) {
            let router = {
                path: '/prodetail',
                name: 'proDetail',
                params: { code: val}
            };
            this.$router.push(router)
        }
    }
}
</script>

<style scoped lang="less">
    .product {
        width: 100%;
        min-height: 100%;
        display: flex;
        flex-direction: column;
        .content {
            flex: 1;
            padding: 0 20px;
            color: #ffffff;
            .text-item {
                margin: 20px 0;
                .title {
                    height: 30px;
                    line-height: 30px;
                    font-size: 24px;
                }
                .english {
                    font-size: 14px;
                }
                .intro {
                    height: 40px;
                    line-height: 40px;
                }
            }
            .img-items {
                display: flex;
                .img-item {
                    flex: 1;
                    position: relative;
                    cursor: pointer;
                    .img {
                        border: solid 1px #ffffff87;
                        padding: 10px 0;
                        text-align: center;
                        min-height: 200px;
                        img{
                            transition: all 0.5s;
                        }
                    }
                    .name {
                        text-align: center;
                        border: 1px solid #ffffff87;
                        width: 70%;
                        border-radius: 30px;
                        margin: auto;
                        margin-top: 20px;
                        padding: 5px 0;
                    }
                    &:hover {
                        .img {
                            img{
                                transform: scale(1.05);
                            }
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/product.vue